webpackJsonp([35783957827783],{

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleModule = __webpack_require__(103);
	
	var _styleModule2 = _interopRequireDefault(_styleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Box = function Box(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: _styleModule2.default.padded + ' ' + _styleModule2.default.headerFont },
	    children
	  );
	};
	
	exports.default = Box;
	module.exports = exports['default'];

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"padded":"src-components-Box----style-module---padded---3KvQj"};

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleModule = __webpack_require__(104);
	
	var _styleModule2 = _interopRequireDefault(_styleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = function Button(_ref) {
	  var to = _ref.to,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'a',
	    { href: to, className: '' + _styleModule2.default.button },
	    children
	  );
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"src-components-Button----style-module---button---2dnz7"};

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(63);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styleModule = __webpack_require__(105);
	
	var _styleModule2 = _interopRequireDefault(_styleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'div',
	    { className: _styleModule2.default.header },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Climb and Bloom',
	      _react2.default.createElement(
	        'svg',
	        { className: _styleModule2.default.leaf, viewBox: '0 0 64 48', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement(
	          'g',
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            'Layer 1'
	          ),
	          _react2.default.createElement('path', { id: 'svg_1', d: 'M51.83 1.62C47.74 -1.95 -7.23 9.24 2.06 55.64C53.1 60.31 55.92 5.18 51.83 1.62Z', fill: '#29ca38' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Radically effective startup support'
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-components-Header----style-module---header---31rfm","leaf":"src-components-Header----style-module---leaf---1cRDS"};

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Button = exports.Box = exports.Header = undefined;
	
	var _Header = __webpack_require__(75);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Box = __webpack_require__(73);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Button = __webpack_require__(74);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Header = _Header2.default;
	exports.Box = _Box2.default;
	exports.Button = _Button2.default;

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"src-pages----home-module---content---t49CP"};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(63);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _components = __webpack_require__(76);
	
	var _homeModule = __webpack_require__(297);
	
	var _homeModule2 = _interopRequireDefault(_homeModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      _components.Box,
	      null,
	      _react2.default.createElement(_components.Header, null),
	      _react2.default.createElement(
	        'div',
	        { className: _homeModule2.default.content },
	        _react2.default.createElement(
	          'p',
	          null,
	          ' We like to keep things simple. '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          ' If you have a product or a startup, we specialise in making you more successful. That\'s it. '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          ' For brand new founders, we help with technical roadmapping. If you\'ve already launched something, maybe you\'d like support on monitoring and analysing the results. Or if you have a product that\'s struggling, we can help identify problems with your team and processes. '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          ' We\'ll save you time and money, and help your products reach the vision that you\'ve set for them.'
	        )
	      ),
	      _react2.default.createElement(
	        _components.Button,
	        { to: 'mailto:alex@climbandbloom.com' },
	        'Contact us'
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ac01e138bab24112fca6.js